import { RPCDocs } from "../../../../services/rpc.js";
import { clusterGpsFlags } from "./gps-windows.js";
import dayjs from "dayjs";
//#region src/modules/Scheduling/shared/shift-flags/flag-helpers.ts
var Type = RPCDocs.Scheduling.StartShift.v1.Type;
function getTierForType(type) {
	return type === Type.Missed || type === Type.GpsOutOfBounds ? "problem" : "minor";
}
function getFlagTier(flag) {
	return getTierForType(flag.type);
}
/** Short label used on a single-flag Badge chip, e.g. "Late start 14m". */
function formatFlagLabel(flag) {
	switch (flag.type) {
		case Type.Missed: return "Missed";
		case Type.GpsOutOfBounds: return "GPS out of bounds";
		case Type.StartedLate: return `Late start ${flag.detail.minutes}m`;
		case Type.EndedEarly: return `Early end ${flag.detail.minutes}m`;
		case Type.EndedLate: return `Late end ${flag.detail.minutes}m`;
		case Type.Edited: return "Edited";
		default: return "Flag";
	}
}
/** Short label for a bare type (no minutes), used in the Summary chip row. */
function formatFlagTypeLabel(type) {
	switch (type) {
		case Type.Missed: return "Missed";
		case Type.GpsOutOfBounds: return "GPS out of bounds";
		case Type.StartedLate: return "Late start";
		case Type.EndedEarly: return "Early end";
		case Type.EndedLate: return "Late end";
		case Type.Edited: return "Edited";
		default: return "Flag";
	}
}
/** Tooltip text with the human label, timestamp, and type-specific detail. */
function formatFlagDetail(flag) {
	const when = dayjs(flag.timestamp).format("MMM D, h:mm a");
	switch (flag.type) {
		case Type.Missed: return `Missed shift — flagged ${when}`;
		case Type.GpsOutOfBounds: {
			const departed = flag.detail?.departDetectedTimestamp;
			return departed ? `GPS left the assigned area at ${dayjs(departed).format("MMM D, h:mm a")}` : `GPS out of bounds — flagged ${when}`;
		}
		case Type.StartedLate: return `Started ${flag.detail.minutes}m late (${when})`;
		case Type.EndedEarly: return `Ended ${flag.detail.minutes}m early (${when})`;
		case Type.EndedLate: return `Ended ${flag.detail.minutes}m late (${when})`;
		case Type.Edited: {
			const changed = Object.keys(flag.detail?.toProps ?? {});
			return changed.length ? `Shift edited ${when} — changed: ${changed.join(", ")}` : `Shift edited ${when}`;
		}
		default: return `Flagged ${when}`;
	}
}
function summarizeFlags(flags) {
	const summary = {
		byType: {},
		gpsDurationMs: 0,
		minor: 0,
		problem: 0
	};
	if (!flags) return summary;
	const gpsFlags = flags.filter((flag) => flag.type === Type.GpsOutOfBounds);
	flags.filter((flag) => flag.type !== Type.GpsOutOfBounds).forEach((flag) => {
		if (getFlagTier(flag) === "problem") summary.problem += 1;
		else summary.minor += 1;
		summary.byType[flag.type] = (summary.byType[flag.type] ?? 0) + 1;
	});
	const windows = clusterGpsFlags(gpsFlags);
	if (windows.length > 0) {
		summary.byType[Type.GpsOutOfBounds] = windows.length;
		summary.problem += windows.length;
		summary.gpsDurationMs = windows.reduce((sum, w) => sum + w.durationMs, 0);
	}
	return summary;
}
//#endregion
export { formatFlagDetail, formatFlagLabel, formatFlagTypeLabel, getFlagTier, getTierForType, summarizeFlags };

//# sourceMappingURL=flag-helpers.js.map